import Vue from 'vue'
// 自义定指令 focus
Vue.directive('focus', {
    inserted(el) {
        el.focus()
    }
})